import { COLORS, DOWNTILT_PREVIEW_DIMENSIONS } from 'helpers/globals'

export default {
  container: {
    width: DOWNTILT_PREVIEW_DIMENSIONS.width,
    height: DOWNTILT_PREVIEW_DIMENSIONS.height,
    border: `1px solid ${COLORS.quaternary}`,
    borderLeft: 'none',
    borderRight: 'none',
    overflow: 'hidden',
    position: 'absolute',
    right: 0,
    backgroundSize: '20px 20px',
    backgroundImage: 'radial-gradient(circle, #000000 1px, rgba(0, 0, 0, 0) 1px)',
    '& canvas': { width: '100%', height: '100%' }
  }
}



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/DowntiltDisplay/style.js